import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "shop-form__block" }
const _hoisted_2 = { class: "shop-form__table _designs" }
const _hoisted_3 = ["onClick"]

import { computed } from "vue";
import { useStore } from "vuex";
import { TypeDesignObj } from "@/types/typesOfApi";
import { TypeLoyalityKinds } from "@/types";

export default /*#__PURE__*/_defineComponent({
  __name: 'stepSetDesign',
  setup(__props) {

const store = useStore();

const currentLoyalityKind = computed<TypeLoyalityKinds>(() => store.state.currentLoyalityKind);

const currentDesingType = computed<number>(
  () => store.state.loyalityShopData.designType
);

const allDesignTypes = computed<TypeDesignObj[]>(() => store.state.allDesignTypes);

const sortedDesignByCurrentType = computed(() => {
  if (currentLoyalityKind.value === 'abonement') {
    return allDesignTypes.value.filter(i => i.loyalty_type === 'abon')
  } else {
    return allDesignTypes.value.filter(i => i.loyalty_type === 'cert')
  }
})

function setDesingType(typeId: number): void {
  store.state.loyalityShopData.designType = typeId;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedDesignByCurrentType.value, (designType) => {
        return (_openBlock(), _createElementBlock("span", {
          class: _normalizeClass(["shop-form__design", { active: currentDesingType.value === designType.id }]),
          key: designType.id,
          onClick: ($event: any) => (setDesingType(designType.id)),
          style: _normalizeStyle(`background: url(${designType.image}) no-repeat center/ 110%;`)
        }, null, 14, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})